<template>
  <div class="integrity">
    <el-row justify="center">
      <el-col :span="20" align="center">
        <div :span="2" class="integrity-call">
          <div class="pt-3" v-html="data.call"></div>
        </div>
      </el-col>
    </el-row>

    <el-row justify="center" class="pt-5">
      <el-col :span="22" class="integrity-channels">
        <el-row justify="center" class="pt-5">
          <el-col :span="7" class="integrity-channels--box" align="right">
            <h3>Canal de Integridade</h3>
          </el-col>
          <el-col :span="2" class="integrity-channels--box" align="center">
            <figure>
              <img
                class="icon"
                alt="Vue logo"
                src="../../assets/images/integridade/mao.png"
              />
            </figure>
          </el-col>
          <el-col :span="10" class="integrity-channels--box" align="left">
            <h4>
              Denúncias de irregularidades, condutas duvidosas e negociações
              suspeitas têm voz ativa: a sua
            </h4>
            <el-button class="know-more" round><a href="https://aloetica.com.br/otrs/canal-de-etica.pl?Subaction=NewCompliant;CustomerID=pixeon.com.br;Language=pt_BR" target="blank">ACESSE AQUI</a></el-button>
          </el-col>
        </el-row>
        <el-row justify="space-around" class="pt-5 pb-5">
          <el-col :span="5" align="center" class="integrity-channels--cat">
            <figure>
              <img
                class="icon"
                alt="Vue logo"
                src="../../assets/images/integridade/mao-2.png"
              />
            </figure>
            <p><strong>DENÚNCIA</strong></p>
            <span>
              VOCÊ FAZ A DENÚNCIA.
            </span>
          </el-col>
          <el-col :span="5" align="center" class="integrity-channels--cat">
            <figure>
              <img
                class="icon"
                alt="Vue logo"
                src="../../assets/images/integridade/cadeado.png"
              />
            </figure>
            <p><strong>EMPRESA SIGILOSA</strong></p>
            <span>
              UMA EMPRESA IDÔNEA, ESPECIALIZADA, DE MANEIRA SIGILOSA RECEBE AS INFORMAÇÕES.
            </span>
          </el-col>
          <el-col :span="5" align="center" class="integrity-channels--cat">
            <figure>
              <img
                class="icon"
                alt="Vue logo"
                src="../../assets/images/integridade/comite.png"
              />
            </figure>
            <p><strong>COMITÊ</strong></p>
            <span>
              UM COMITÊ DE INTEGRIDADE ANALISA TODOS OS CASOS.
            </span>
          </el-col>
          <el-col :span="5" align="center" class="integrity-channels--cat">
            <figure>
              <img
                class="icon"
                alt="Vue logo"
                src="../../assets/images/integridade/tratativa.png"
              />
            </figure>
            <p><strong>TRATATIVAS</strong></p>
            <span>
              TRATATIVAS SÃO DIRECIONADAS.
            </span>
          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <el-row justify="center" class="mt-5">
      <el-col :span="20" align="center">
        <div class="education-call">
          <button
              class="btn-login btn-position btn-change-color"
              type="primary"
              round
            >
            <a href="https://www.pixeon.com/wp-content/uploads/2021/12/Codigo-de-Etica-e-Conduta-1.5.pdf" target="blank">
              Acesse o Código de Ética e de Conduta
            </a>
            </button>
        </div>
      </el-col>
    </el-row>

    <el-row justify="center" class="mt-3 mb-5">
      <el-col :span="20" align="center">
        <div class="integrity-call">
          <div v-html="data.comoUsar"></div>

          <!-- <h3 class="pt-3">COMO USAR O CANAL DE INTEGRIDADE?</h3>
          <p class="pt-3">
            Para ajudar nosso #dreamteam no entendimento sobre o direcionamento
            de situações criamos um GUIA DE DENÚNCIA. Nele, mostramos exemplos
            de quando chamar o colega ou o líder para uma conversa, de quando
            relatar o problema à área de Pessoas e Cultura e de quanto seguir com uma denúncia via
            Canal de Integridade.
          </p> -->
        </div>
      </el-col>
    </el-row>
    <el-row class="pt-5 cards" justify="space-around">
      <el-col :span="5" align="center" v-for="card of data.cards" :key="card.title">
        <card :card-data="card"></card>
      </el-col>
    </el-row>

    <el-row justify="center" class="mt-5 mb-5">
      <el-col :span="22" class="stakeholders mb-5">
        <h3 class="pt-3">COMITÊ DE ÉTICA E INTEGRIDADE</h3>
        <el-row justify="center" class="pt-5">
          <el-col align="center">
            <figure>
              <img
                class="icon"
                alt="Vue logo"
                :src="data.badge1?.imgPath"
              />
            </figure>
            <p><strong>{{data.badge1?.name}} </strong></p>
            <span>{{data.badge1?.cargo}}</span>
          </el-col>
        </el-row>

        <el-row justify="space-around" class="pt-5 pb-5 ethic-persons">

          <el-col :span="3" align="center">
            <figure>
              <img
                class="icon"
                alt="Vue logo"
                :src="data.badge3?.imgPath"
              />
            </figure>
            <p><strong>{{data.badge3?.name}} </strong></p>
            <span>{{data.badge3?.cargo}}</span>
          </el-col>
          <el-col :span="3" align="center">
            <figure>
              <img
                class="icon"
                alt="Vue logo"
                :src="data.badge4?.imgPath"
              />
            </figure>
            <p><strong>{{data.badge4?.name}} </strong></p>
            <span>{{data.badge4?.cargo}}</span>
          </el-col>
          <el-col :span="3" align="center">
            <figure>
              <img
                class="icon"
                alt="Vue logo"
                :src="data.badge5?.imgPath"
              />
            </figure>
            <p><strong>{{data.badge5?.name}} </strong></p>
            <span>{{data.badge5?.cargo}}</span>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Card from '@/components/card/Card.vue'
import axios from 'axios'
import { ref, onBeforeMount } from 'vue'
import { firebaseRoutes } from '../../config/firebase.conf'
export default {
  name: 'Integrity',
  components: {
    Card
  },
  setup () {
    const data = ref({})

    onBeforeMount(async () => {
      data.value = await axios.get(firebaseRoutes.integridade).then((response) => {
        const result = []
        for (const id in response.data) {
          result.push({
            id: id,
            call: response.data[id].call,
            comoUsar: response.data[id].comoUsar,
            cards: response.data[id].cards,
            badge1: response.data[id].badge1,
            badge2: response.data[id].badge2,
            badge3: response.data[id].badge3,
            badge4: response.data[id].badge4,
            badge5: response.data[id].badge5
          })
        }
        return result[0]
      })
    })

    return {
      data
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";
@import "~@/styles/mixin.scss";

.cards {
  height: 45rem;
}

.integrity-call {
  h1{
    font-size: 3rem;
    font-weight: bold;
  }

  h3 {
    color: $blue;
  }
  max-width: 98rem;
}

.integrity-channels {
  background-color: $white;
}

.integrity-channels--box {
  background-color: $green;
  padding: 2rem;
  color: $white;
  h3 {
    color: $white;
    line-height: 3rem;
    text-transform: uppercase;
  }

  h4 {
    line-height: 2rem;
    font-size: 1.4rem;
  }

  img {
    height: 6rem;
  }

  &:first-child {
    border-top-left-radius: 1rem;
    border-bottom-left-radius: 1rem;
  }

  &:last-child {
    border-top-right-radius: 1rem;
    border-bottom-right-radius: 1rem;
  }
}
.integrity-channels--cat {
  img {
    height: 4rem;
  }

  span {
    font-size: 1.2rem;
    max-width: 15rem;
    display: block;
  }
}
.stakeholders {
  text-align: center;
  img {
    height: 9rem;
  }

  p {
    font-size: 1.2rem;
  }

  span {
    font-size: 1rem;
  }

  h3 {
    color: $blue;
  }
}
.ethic-persons {
  padding-left: 10rem;
  padding-right: 10rem;
}

.know-more{
  margin-top: 1rem;
  a {
    color: $white;
    padding: 0 ;
    margin: 0;
  }
}

.btn-change-color {
  @include gradientBackgroundBlueStart;
}
</style>
